import { useState, useMemo } from 'react';
import ShopLayout from '../components/ShopLayout';
import DealCard from '../components/DealCard';
import { FIBRE, FIBRE_CATEGORIES } from '../data/fibre';

export default function FibrePage() {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('All');

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return FIBRE.filter(f => {
      const matchCat = category === 'All' || f.category === category;
      const matchSearch = !q || f.name.toLowerCase().includes(q);
      return matchCat && matchSearch;
    });
  }, [search, category]);

  return (
    <ShopLayout
      title="Fibre Deals"
      subtitle="Ultra-fast home fibre. Free installation and router for new customers."
      search={search}
      onSearch={setSearch}
      filters={FIBRE_CATEGORIES}
      activeFilter={category}
      onFilter={setCategory}
    >
      {filtered.length === 0
        ? <p className="shop-empty">No deals match your search.</p>
        : filtered.map(f => <DealCard key={f.id} deal={f} type="fibre" />)
      }
    </ShopLayout>
  );
}
